import { ArrowLeftIcon, CaretDownIcon, SquaresFourIcon, ChatsCircleIcon, PlayCircleIcon, ImageIcon, QuestionIcon, UsersThreeIcon, LinkIcon } from "@phosphor-icons/react";
import { useRouter } from 'next/router';
import { useState } from 'react';
import SidebarMenuItem from './SidebarMenuItem';

type ReportsSidebarProps = {
  isExpanded: boolean;
  onBack: () => void;
}

const menuItems = [
  { id: 'overview', label: 'Overview', icon: SquaresFourIcon },
  { id: 'chatChart', label: 'Chat Chart', icon: ChatsCircleIcon },
  { id: 'replayResults', label: 'Replay Results', icon: PlayCircleIcon },
  { id: 'screenshots', label: 'Shareable Images', icon: ImageIcon },
];

const trackItems = [
  { id: 'quickQuestions', label: 'Quick Questions', icon: QuestionIcon },
  { id: 'fantasticFans', label: 'Fantastic Fans', icon: UsersThreeIcon },
  { id: 'linkLibrary', label: 'Link Library', icon: LinkIcon },
];

export default function ReportsSidebar({
  isExpanded,
  onBack
}: ReportsSidebarProps) {
  const router = useRouter();
  const currentPage = (router.query.page as string) || 'overview';
  const [isTrackOpen, setIsTrackOpen] = useState(true);

  const handlePageChange = (page: string) => {
    router.replace({
      pathname: router.pathname,
      query: { ...router.query, page }
    }, undefined, { shallow: true });
  };

  return (
    <div className={`${isExpanded ? 'px-6' : 'flex flex-col items-center'} mt-6 text-sm`}>
      <div className='flex flex-col gap-4'>
        <SidebarMenuItem
          label="Back"
          icon={<ArrowLeftIcon size={20} />}
          isExpanded={isExpanded}
          onClick={onBack}
        />

        {isExpanded && (
          <div className='px-2'>
            <p className='text-sm text-default-600'>Reports</p>
          </div>
        )}

        <div className='flex flex-col gap-1 -mt-2'>
          {menuItems.map((item) => (
            <SidebarMenuItem
              key={item.id}
              label={item.label}
              icon={<item.icon size={20} />}
              isExpanded={isExpanded}
              isActive={currentPage === item.id}
              onClick={() => handlePageChange(item.id)}
            />
          ))}

          {/* Track Section */}
          <button
            onClick={() => setIsTrackOpen(!isTrackOpen)}
            className='rounded-md flex items-center px-2 py-1.5 h-8 gap-4 text-left w-full text-default-700 hover:bg-content3'
          >
            <div className='w-5 h-5 flex items-center'>
              <CaretDownIcon
                size={16}
                className={`transition-transform ${isTrackOpen ? '' : '-rotate-90'}`}
              />
            </div>
            {isExpanded && <span className='text-sm'>Track</span>}
          </button>

          {isTrackOpen && (
            <div className='flex flex-col gap-1 pl-4'>
              {trackItems.map((item) => (
                <SidebarMenuItem
                  key={item.id}
                  label={item.label}
                  icon={<item.icon size={20} />}
                  isExpanded={isExpanded}
                  isActive={currentPage === item.id}
                  onClick={() => handlePageChange(item.id)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
